import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {CustomValidator} from '../../../services/custom-validator';
import {ChangePasswordService} from '../../../services/change-password.service';
import {throwError} from 'rxjs';
import {GenericModalService} from '../../../services/generic-modal.service';
import {InsertPasswordModalComponent} from './insert-password-modal/insert-password-modal.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css', '../../../styles/modals.css']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('passTabs', { static: false }) passTabs: TabsetComponent;
  modalTitle;
  changePassForm: FormGroup;
  errorMessage = '';
  successMessage = '';
  user;
  hasCrivoUserConfigured = false;

  get formData() { return this.changePassForm.controls; }
  get formDataWorkflow() { return this.formData.workflowPasswordFields['controls']; }
  get formDataCrivo() { return this.formData.crivoPasswordFields['controls']; }

  constructor(private formBuilder: FormBuilder, public bsModalRef: BsModalRef, private changePassService: ChangePasswordService,
              private modalService: GenericModalService) { }

  ngOnInit() {
    this.loadUserConfig();
  }

  createForm() {
    this.changePassForm = this.formBuilder.group({
      workflowPasswordFields: this.formBuilder.group({ passwordHash: '', passwordRetype: '' }),
      crivoPasswordFields: this.formBuilder.group({ crivoUser: this.user.crivoUser, crivoPassword: '', crivoPasswordRetype: '' })
    })
  }

  loadUserConfig() {
    this.changePassService.loadUserConfig()
      .subscribe(result => {
        result.crivoUser = result.crivoUser || '';
        this.user = { userId: result.userId, logon: result.logon, crivoUser: result.crivoUser, isLdap: result.isLdap };
        this.hasCrivoUserConfigured = this.user.crivoUser !== '';
        this.createForm();
      });
  }

  setWorkflowRequiredField(element) {
    const val = element.target.value;
    if (val !== '') {
      this.formDataWorkflow.passwordHash.setValidators([ Validators.required, Validators.maxLength(100) ]);
      this.formDataWorkflow.passwordRetype.setValidators([ Validators.required, Validators.maxLength(100) ]);
      this.changePassForm.controls['workflowPasswordFields'].setValidators(CustomValidator.validatePassword('passwordHash', 'passwordRetype'));
    } else {
      // verificar se o outro campo está em branco tb
      const passwordHash = this.formDataWorkflow.passwordHash.value;
      const passwordRetype = this.formDataWorkflow.passwordRetype.value;
      if (passwordHash == '' && passwordRetype == '') {
        this.formDataWorkflow.passwordHash.clearValidators();
        this.formDataWorkflow.passwordRetype.clearValidators();
        this.changePassForm.controls['workflowPasswordFields'].clearValidators();
      }
    }
    this.formDataWorkflow.passwordHash.updateValueAndValidity();
    this.formDataWorkflow.passwordRetype.updateValueAndValidity();
    this.changePassForm.updateValueAndValidity();
  }

  setUserCrivoValidations(element) {
    const val = element.target.value;

    // se está cadastrando por aqui...
    if (val !== '' && !this.hasCrivoUserConfigured) {
      this.setCrivoPasswordValidators();
    } else {
      const passwordHash = this.formDataCrivo.crivoPassword.value;
      const passwordRetype = this.formDataCrivo.crivoPasswordRetype.value;

      // se algum campo de senha está preenchido, o usuário crivo é obrigatório e não devo remover a obrigatoriedade dos campos de senha
      if (passwordHash !== '' || passwordRetype !== '') {
        this.setCrivoUserValidators();
      } else {
        this.setCrivoUserValidators(false);
        this.setCrivoPasswordValidators(false);
      }
    }
  }

  setCrivoPasswordRequiredField(element) {
    const crivoUser = this.formDataCrivo.crivoUser.value;
    const val = element.target.value;
    // se não tiver cadastrado na base o usuário crivo e tiver preenchido o campo, as senhas do crivo são obrigatórias
    if (val !== '' || (!this.hasCrivoUserConfigured && crivoUser !== '')) {
      this.setCrivoPasswordValidators();
      this.setCrivoUserValidators();
    } else {
      const passwordHash = this.formDataCrivo.crivoPassword.value;
      const passwordRetype = this.formDataCrivo.crivoPasswordRetype.value;

      // se as duas senhas estão preenchidas... deixa de ser obrigatório o campo, caso o campo usuário crivo esteja preenchido e não tenha o usuário configurado
      if (passwordHash == '' && passwordRetype == '') { // && crivoUser == '' && !this.hasCrivoUserConfigured
        if (crivoUser !== '' && this.hasCrivoUserConfigured) {
          this.setCrivoPasswordValidators(false);
        } else if (crivoUser == '') {
          this.setCrivoPasswordValidators(false);
          this.setCrivoUserValidators(false);
        }
      }
    }
  }

  setCrivoUserValidators(enableValidators = true) {
    if (enableValidators) {
      this.formDataCrivo.crivoUser.setValidators([ Validators.required, Validators.maxLength(100) ]);
    } else {
      this.formDataCrivo.crivoUser.clearValidators();
    }
    this.formDataCrivo.crivoUser.updateValueAndValidity();
  }

  setCrivoPasswordValidators(enableValidators = true) {
    if (enableValidators) {
      this.formDataCrivo.crivoPassword.setValidators([ Validators.required, Validators.maxLength(100) ]);
      this.formDataCrivo.crivoPasswordRetype.setValidators([ Validators.required, Validators.maxLength(100) ]);
      this.changePassForm.controls['crivoPasswordFields'].setValidators(CustomValidator.validatePassword('crivoPassword', 'crivoPasswordRetype'));
    } else {
      this.formDataCrivo.crivoPassword.clearValidators();
      this.formDataCrivo.crivoPasswordRetype.clearValidators();
      this.changePassForm.controls['crivoPasswordFields'].clearValidators();
    }
    this.formDataCrivo.crivoPassword.updateValueAndValidity();
    this.formDataCrivo.crivoPasswordRetype.updateValueAndValidity();
    this.changePassForm.updateValueAndValidity();
  }

  onSave() {

    const modalComponent: any = InsertPasswordModalComponent;
    const result$ = this.modalService.showObjModal(modalComponent,
      'Informe a senha', { values: this.changePassForm.getRawValue(), user: this.user }, 'modal-md');
    result$.asObservable()
      .pipe()
      .subscribe(
        isAuth => {
          if (isAuth) {
            this.ngOnInit();
            this.passTabs.tabs[0].active = true;
          }
        }
      );
  }

  onClose() {
    this.bsModalRef.hide();
  }

}
